export default "__VITE_ASSET__hRBNDC2G__"